import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n';
import PageHero from '../components/PageHero';
import HighlightPhrase from '../components/HighlightPhrase';
import { SectionWrap, SectionHeader, Bullets, TitledBullets, Prose } from '../components/SectionPrimitives';

import { VIDAT_IMG } from '../lib/images';

const IMG = VIDAT_IMG.manos;

const MedicinaFamilia = () => {
  const { content } = useI18n();
  const f = content.family;
  const buttons = content.buttons;
  return (
    <main data-testid="family-page">
      <PageHero eyebrow={f.eyebrow} title={f.title} lead={f.lead} image={IMG} testId="family-hero" />

      <SectionWrap bg="ivory">
        <Prose paragraphs={[f.lead2]} />
      </SectionWrap>

      <SectionWrap testId="family-forwhom">
        <SectionHeader title={f.forWhomTitle} />
        <p className="text-stone-700 font-light max-w-3xl mb-6">{f.forWhomLead}</p>
        <p className="text-stone-700 font-light max-w-2xl mb-6">{f.forWhomIntro}</p>
        <Bullets items={f.forWhom} />
      </SectionWrap>

      <SectionWrap bg="ivory" testId="family-problem">
        <SectionHeader title={f.problemTitle} />
        <Prose paragraphs={[f.problemP1, f.problemP2, f.problemP3]} />
      </SectionWrap>

      <SectionWrap testId="family-consult">
        <SectionHeader title={f.consultTitle} />
        <Prose paragraphs={[f.consultP1, f.consultP2]} />
        <div className="mt-8"><TitledBullets items={f.consultList} /></div>
        <p className="mt-8 text-stone-700 font-light max-w-3xl leading-relaxed">{f.consultOutro}</p>
      </SectionWrap>

      <SectionWrap bg="ivory" testId="family-integration">
        <SectionHeader title={f.integrationTitle} />
        <Prose paragraphs={[f.integrationP1, f.integrationP2]} />
        <div className="mt-8"><Bullets items={f.integrationList} /></div>
        <p className="mt-8 text-stone-700 font-light max-w-3xl leading-relaxed">{f.integrationOutro}</p>
      </SectionWrap>

      <SectionWrap testId="family-follow">
        <SectionHeader title={f.followTitle} />
        <Prose paragraphs={[f.followP1, f.followP2]} />
        <div className="mt-8"><Bullets items={f.followList} /></div>
        <p className="mt-8 text-stone-700 font-light max-w-3xl leading-relaxed">{f.followOutro}</p>
      </SectionWrap>

      <SectionWrap bg="ivory" testId="family-obtain">
        <SectionHeader title={f.obtainTitle} />
        <Bullets items={f.obtain} />
      </SectionWrap>

      <HighlightPhrase eyebrow={f.modelEyebrow} dark testId="family-highlight">
        {f.modelP1}
      </HighlightPhrase>

      <SectionWrap testId="family-model-outro">
        <Prose paragraphs={[f.modelP2]} />
        <div className="mt-12">
          <Link to="/programar-visita" className="btn-primary" data-testid="family-cta-join">
            {buttons.joinList}
          </Link>
        </div>
      </SectionWrap>

    </main>
  );
};

export default MedicinaFamilia;
